import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=410fc2bd&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410fc2bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('410fc2bd')) {
      api.createRecord('410fc2bd', component.options)
    } else {
      api.reload('410fc2bd', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=410fc2bd&scoped=true&", function () {
      api.rerender('410fc2bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bcd0yu2ryi1i/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports